<template>
    <div>
        <b-form-group
            class="answer-list-group"
            v-for="(item, key) in partIn.list_items"
            :key="item.id"
            :label="`${key + 1}. ${item.value}`"
            :label-for="`answer-select-${key + 1}`"
            :class="partIn.isAssignmentCheckList() && 'hide-label'">
            <b-form-radio-group
                class="apprentice-radiobutton"
                v-if="partIn.isAssignmentStandardList() && common.isCreathlonProjec($groupType)"
                stacked
                :id="`answer-radio-group-${item.id}`"
                :options="getOptions(item.type)"
                :name="`answer-radio-group-${item.id}`"
                @change="onChange($event, item.id)">
            </b-form-radio-group>

            <b-form-select
                class="apprentice-primary-select assignment-answer-select"
                v-else-if="partIn.isAssignmentStandardList() && !common.isCreathlonProjec(groupTypeIdIn)"
                :id="`answer-select-${key + 1}`"
                :disabled="isDisabled"
                :options="getOptions(item.type)"
                @change="onChange($event, item.id)"
                :value="checkValue(item.type, item.id)"
                value-field="id"
                text-field="value">
            </b-form-select>

            <design-2021-assignment-show-answer-list-color-component
                v-if="partIn.isAssignmentColorList()"
                :id="`answer-select-${key + 1}`"
                :part-in="partIn"
                :item-id="item.id"
                :is-preview-in="isExampleIn"
                :can-answer="canAnswer"
                :group-type-id-in="groupTypeIdIn"
                :project-id="projectId">
            </design-2021-assignment-show-answer-list-color-component>

            <design-2021-assignment-show-answer-list-checkbox-component
                class="checkbox-list-group"
                v-if="partIn.isAssignmentCheckList()"
                :id="`answer-select-${key + 1}`"
                :part-in="partIn"
                :item-in="item"
                :can-answer="canAnswer"
                :project-id="projectId"
                :index-in="key + 1">
            </design-2021-assignment-show-answer-list-checkbox-component>
        </b-form-group>
    </div>
</template>

<script>
import { Common as common } from '../../../../../../helpers/common';

export default {
    name: 'design-2021-assignment-show-answer-list-component',
    props: ['partIn', 'canAnswer', 'projectId', 'isExampleIn', 'groupTypeIdIn'],
    data() {
        return {
            active: false,
            selectedColor: '',
            selectedColorName: '',
        };
    },
    computed: {
        common() {
            return common;
        },
        selector: function () {
            if (!this.selectedColor) {
                return 'Kies een kleur';
            } else {
                return '<span style="background: ' + this.selectedColor + '"></span> ' + this.selectedColorName;
            }
        },
        isDisabled() {
            if (this.isExampleIn) {
                return false;
            } else {
                return !this.canAnswer;
            }
        },
        checkedValue: {
            get(type, id) {
                if (!this.partIn.hasAnswer()) {
                    return null;
                }

                let target_item = null;

                for (const item of this.partIn.getAnswer().list_items) {
                    if (item.item_id === id) {
                        target_item = item;
                        break;
                    }
                }

                return target_item ? 1 : null;
            },
            set(newVal) {
                this.value = newVal / 2;
            },
        },
    },
    methods: {
        setColor: function (color, colorName) {
            this.selectedColor = color;
            this.selectedColorName = colorName;
            this.active = false;
        },
        toggleDropdown: function () {
            this.active = !this.active;
        },
        getCheckboxOptionId() {
            return this.partIn.list_options.filter((option) => option.type === 3)[0].id;
        },
        getOptions(type) {
            let options = this.partIn.list_options.filter((option) => option.type === type && option.value !== null);

            if (this.common.isCreathlonProjec(this.$groupType)) {
                options = options.map((option) => {
                    return {
                        text: option.value,
                        value: option.id,
                    };
                });
            } else {
                options.unshift({
                    id: 0,
                    value: 'Maak een keuze',
                });
            }

            return options;
        },
        checkValue(type, id) {
            if (!this.partIn.hasAnswer()) {
                return 0;
            }

            return this.partIn.getAnswer().hasListItem(id) ? this.partIn.getAnswer().getListItem(id).option_id : 0;
        },
        onChange(value, id) {
            if (!this.isExampleIn) {
                if (!this.partIn.hasAnswer()) {
                    const data = {
                        value: {
                            option_id: value,
                            item_id: id,
                        },
                        part_id: this.partIn.id,
                        project_id: this.projectId,
                    };

                    this.axios.post(this.routes.assignmentAnswer(), data).then(
                        (response) => {
                            this.partIn.addRelation('answers', response.data);
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                } else {
                    const data = {
                        option_id: value,
                        item_id: id,
                        answer_id: this.partIn.getAnswer().id,
                    };

                    if (!this.partIn.getAnswer().hasListItem(id)) {
                        // create list item answer
                        this.axios.post(this.routes.assignmentAnswerList(), data).then(
                            (response) => {
                                this.partIn.getAnswer().addRelation('list_items', response.data);
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    } else {
                        // update
                        this.axios
                            .post(
                                this.routes.assignmentAnswerListUpdate(this.partIn.getAnswer().getListItem(id).id),
                                data,
                            )
                            .then(
                                (response) => {
                                    if (!response.data || !response.data.length) {
                                        this.partIn.getAnswer().getListItem(id).remove();
                                    } else {
                                        this.partIn.getAnswer().getListItem(id).update(response.data);
                                    }
                                },
                                (error) => {
                                    this.alert.ajaxError(error);
                                },
                            );
                    }
                }
            }
        },
    },
};
</script>

<style scoped lang="scss">
.answer-list-group ::v-deep {
    &:not(:last-child) {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteeen');
    }
}

.answer-list-group.hide-label ::v-deep {
    > label {
        display: none !important;
    }
}

.answer-list-select,
.assignment-answer-select {
    border: 1px solid $primary;
    min-width: 250px;
    width: auto;
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .answer-list-select,
    .assignment-answer-select {
        max-width: 450px;
    }
}
</style>
